import React, {createContext, useState, useContext} from 'react';
import PropTypes from 'prop-types';

export const PaymentRequestContext = createContext();

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';
const DATA_MISSING_ERROR = 'DATA_MISSING_ERROR';


export const PaymentRequestProvider = ({children}) => {
        const [supportedInstruments, setSupportedInstruments] = useState();
    const [userDetails, setUserDetails] = useState();
    const [userOptions, setUserOptions] = useState();
    const [paymentData, setPaymentData] = useState();
    const [status, setStatus] = useState(INIT);
    const [paymentError, setPaymentError] = useState();
    const [canMakePaymentPromise, setCanMakePaymentPromise] = useState(Promise.resolve(true));


    const doRequest = (formValues, instruments, details, options) => {

        
        const request = new PaymentRequest(instruments, details, options);

        if (request.canMakePayment) {
            setCanMakePaymentPromise(request.canMakePayment());
        }

        canMakePaymentPromise.then((result) => {
            if (!result) {
                
                setPaymentError('The payment method is not supported');
                setStatus(ERROR);
                return;
            }

            
            request.show().then(pr => {
                
                pr.complete("success").catch(e => {
                    setPaymentError(e.message);
                });
                
                formValues.paymentResponse = JSON.parse(JSON.stringify(pr));
                
                formValues.fullName = formValues.paymentResponse.payerName;
                const fullName = formValues.fullName ? formValues.fullName.split(" ") : [];
                formValues.firstName = fullName.shift() || "";
                formValues.lastName = fullName.pop() || "";

                setPaymentData(formValues);
                // if we don't have a valid firstName, lastName, or address then we need to throw a payment error and have them try again
                if (formValues.firstName === "" || formValues.lastName === ""){
                    setStatus(DATA_MISSING_ERROR);
                }
                else {
                    setStatus(SUCCESS);
                }
            }).catch(e => {
                // according to documentation, AbortError appears to be tied to user cancel interactions only, so
                // the user does not need to see a "Payment Error"
                if (e.name !== 'AbortError') {
                    setPaymentError(e.message);
                    setStatus(ERROR);
                }
            });

        }).catch((e) => {
            setPaymentError(e.message);
            setStatus(ERROR);
        });
    };

    return (
        <PaymentRequestContext.Provider value={{
            doRequest, supportedInstruments, userDetails, userOptions,
            setSupportedInstruments, setUserDetails, setUserOptions,
            paymentError, paymentData, status, setStatus
        }}
        >
            {children}
        </PaymentRequestContext.Provider>
    );
};

PaymentRequestProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export const usePaymentRequest = () => useContext(PaymentRequestContext);
